<script lang="ts" setup>
import ServiceHighlight from "~/components/article/ServiceHighlight.vue";

const {collectionUri} = useI18nCollection();
const {getIndex, getAllButIndex} = usePage();
const pages = await queryCollection(collectionUri('services')).all();
const index = getIndex(pages)!;
const entries = getAllButIndex(pages)!;
</script>

<template>
  <section class="mb-8 text-center">
    <header class="mb-6 max-w-2xl mx-auto">
      <h2 class="section-title text-brand mb-2">{{ index.title }}</h2>
      <ContentRenderer :value="index" class="text-brand/66"/>
    </header>

    <div class="tablet:grid tablet:grid-cols-2 place-items-center gap-12 mb-12 tablet:mb-4">
      <ServiceHighlight
              v-for="(service, index) in entries"
              :key="service.path"
              :title="service.title"
              :price="service.meta?.price"
              :duration="service.meta?.duration"
              class="tablet:max-w-[360px]"
              :class="{ 'ms-auto': index % 2 === 0, 'me-auto': index % 2 !== 0 }"
      >
        <template #summary>
          <ContentRenderer :value="service" class="tablet:text-sm laptop:text-base"/>
        </template>
      </ServiceHighlight>
    </div>
  </section>
</template>

<style scoped>

</style>